export default __webpack_public_path__ + "static/media/logo-social.3139f3a8.svg";